import Link from 'next/link'
import PropTypes from 'prop-types'

import { isBlank, isPresent } from 'utils'

import Text from 'components/Text'

import { LinkedItem, UnlinkedItem } from './BreadcrumbItem.style'

const BreadcrumbItem = ({ url, title, current }) => {
  if (isBlank(title)) return null

  const commonProps = {}

  if (current) commonProps['aria-current'] = 'page'

  if (isPresent(url))
    return (
      <Link href={url} passHref {...commonProps} legacyBehavior>
        <LinkedItem>
          <Text>{title}</Text>
        </LinkedItem>
      </Link>
    )

  return (
    <UnlinkedItem {...commonProps}>
      <Text>{title}</Text>
    </UnlinkedItem>
  )
}

BreadcrumbItem.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string.isRequired,
  current: PropTypes.bool,
}

BreadcrumbItem.defaultProps = {}

export default BreadcrumbItem
